import React, { useEffect, useState, useRef } from 'react'
import { message, Timeline, Spin } from 'antd'
import Modal from 'meinian-package/src/component/modal'
import ReactDOM from 'react-dom'
import { picProcess } from 'meinian-package/src/utils/image'
import { request } from 'meinian-package/src/utils'
import FileTreeData from 'meinian-package/src/common/fileTreeData'
import styles from './index.module.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<RepeatCollectModalApiWrap {...props} visible container={div} />, div)
  })
}

const RepeatCollectModalApiWrap = ({ visible, onClose, data }) => {
  const [_data, set_Data] = useState({})
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    const result = await request.get('/zhikuan/mn/collect-statistic/v2/duplicate-image', {
      params: { collectId: data.collectId },
    })
    set_Data(result)
    setLoading(false)
  }

  return <RepeatCollectModal visible={visible} onClose={onClose} data={_data} loading={loading} />
}

export const RepeatCollectModal = ({ visible, onClose, data, loading = false }) => {
  const currentDot = <div className={styles['analysis-repeat-collect-time-line-item-current-dot']} />
  const dot = <div className={styles['analysis-repeat-collect-time-line-item-dot']} />
  const [_visible, set_Visible] = useState(visible)
  const inspirationTree = useRef()

  const _cancel = () => {
    onClose && onClose()
    set_Visible(false)
  }

  const fetchInspirationTree = async () => {
    const res = await request.post('/zhikuan/ins/inspiration/list-simple-inspiration-tree', {})
    inspirationTree.current = new FileTreeData({
      data: res,
      childrenKey: 'childs',
    })
  }

  useEffect(() => {
    fetchInspirationTree()
  }, [visible])

  const onLink = (current) => {
    const curItem = inspirationTree.current.findNodeByValue(current.inspirationId)
    if (curItem.parent) {
      window.open(
        `/meinian/home/coll/detail/${current.inspirationId}?inspirationId=${current.inspirationId}&parentId=${curItem.parent.value}&name=${curItem.current.label}`
      )
      return
    }
    window.open(`/meinian/home/coll/detail/${current.inspirationId}?inspirationId=${current.inspirationId}`)
  }

  return (
    <Modal
      title="重复采集记录"
      style={{ width: 480 }}
      visible={_visible}
      onCancel={() => _cancel(false)}
      hiddenFooter
      wrapClassName={styles['analysis-repeat-collect-modal']}
    >
      <Spin spinning={loading}>
        <div className={styles['analysis-repeat-collect-modal-context']}>
          <img className="analysis-repeat-collect-modal-context-img" src={picProcess(data?.mainUrl)} />
          <div className="analysis-repeat-collect-modal-context-info">
            <Timeline>
              {data?.collectRecords?.map((item, index) => (
                <Timeline.Item
                  dot={index === 0 ? currentDot : dot}
                  className={styles['analysis-repeat-collect-time-line-item-dot-line']}
                >
                  <TimeLineItem data={item} onClick={() => onLink(item)} />
                </Timeline.Item>
              ))}
            </Timeline>
          </div>
        </div>
      </Spin>
    </Modal>
  )
}

const TimeLineItem = ({ data, onClick }) => {
  return (
    <div className={styles['analysis-repeat-collect-time-line-item']}>
      <a
        onClick={(e) => {
          e.preventDefault()
          if (!data.inspirationAuth) {
            message.info('您没有该灵感集权限！')
          } else {
            onClick()
          }
        }}
      >
        <div className="analysis-repeat-collect-time-line-item-title">{data?.inspirationName || '默认灵感集'}</div>
      </a>
      <div className="analysis-repeat-collect-time-line-item-line2">
        {data?.username || '自己'}
        <span className="line" />
        采集
      </div>
      <div className="analysis-repeat-collect-time-line-item-line2">{data?.collectTime}</div>
    </div>
  )
}
